module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b76a6ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-echarts/components/ECharts.vue
// module id = 471
// module chunks = 103